/**
 * Fluent UI 主题：浅色/深色 + 品牌色 #0A61BC
 */
import type { Theme } from '@fluentui/react-components'
import { webDarkTheme, webLightTheme } from '@fluentui/react-components'

export const BRAND = '#0A61BC'

const brandOverrides: Partial<Theme> = {
  colorBrandBackground: BRAND,
  colorBrandBackgroundHover: '#0b6cd0',
  colorBrandBackgroundPressed: '#084f9a',
  colorBrandBackgroundSelected: BRAND,
  colorBrandForeground1: BRAND,
  colorBrandForeground2: BRAND,
  colorBrandForegroundLink: BRAND,
  colorBrandForegroundLinkHover: '#0b6cd0',
  colorBrandForegroundLinkPressed: '#084f9a',
  colorCompoundBrandStroke: BRAND,
  colorCompoundBrandStrokeHover: '#0b6cd0',
  colorCompoundBrandStrokePressed: '#084f9a',
}

export const lightTheme: Theme = { ...webLightTheme, ...brandOverrides }
export const darkTheme: Theme = { ...webDarkTheme, ...brandOverrides }
